module.exports = __webpack_public_path__ + "img/monthly-sales-graph.1fa0384a.svg";